{
  "version": 1,
  "asset_id": "a433237f-df55-4efc-baae-b1c63a6b0e98",
  "project_id": "6ffb2ed6-aa93-4c00-8eaf-179cce7a3ceb",
  "url": "/__l5e/assets-v1/a433237f-df55-4efc-baae-b1c63a6b0e98/slatrakning-tailors-barber.png",
  "r2_key": "a/v1/6ffb2ed6-aa93-4c00-8eaf-179cce7a3ceb/a433237f-df55-4efc-baae-b1c63a6b0e98/slatrakning-tailors-barber.png",
  "original_filename": "slatrakning-tailors-barber.png",
  "size": 142383,
  "content_type": "image/png",
  "created_at": "2026-07-30T15:51:23Z"
}
